import userData from "@/plugins/userData";

export default {
  mixins: [userData],
  name: "SideBar",
  data() {
    return {
      link: "dashboard",
      isMasterMenuOpen: false,
      userName: "Administrator",
      userEmail: "admin@admin.com",
      userLevel: "user",
      mainMenus: [
        {
          name: "Dashboard",
          to: "/dashboard",
          icon: "tachometer-alt",
          type: "fa",
        },
      ],
      // Semua menu perkebunan (lengkap)
      allPerkebunanMenus: [
        {
          name: "Bantuan Perkebunan",
          to: "/bantuan-perkebunan",
          icon: "seedling",
          type: "fa",
        },
        {
          name: "Bantuan SPHP",
          to: "/bantuan-sphp",
          icon: "tractor",
          type: "fa",
        },
        {
          name: "Pengamatan OPT",
          to: "/pengamatan-opt",
          icon: "bug",
          type: "fa",
        },
        {
          name: "Kebun Sumber Benih",
          to: "/kebun-sumber-benih",
          icon: "tree",
          type: "fa",
        },
        {
          name: "Penangkar Benih",
          to: "/penangkar-benih",
          icon: "seedling",
          type: "fa",
        },
      ],
      // Semua menu peternakan (lengkap)
      allPeternakanMenus: [
        {
          name: "Bantuan Ternak",
          to: "/bantuan-ternak",
          icon: "hand-holding-heart",
          type: "fa",
        },
        {
          name: "Lalu Lintas Hewan",
          to: "/lalu-lintas-ternak",
          icon: "truck-moving",
          type: "fa",
        },
        {
          name: "Inseminasi Buatan",
          to: "/inseminasi-buatan",
          icon: "dna",
          type: "fa",
        },
        {
          name: "Penyakit Hewan",
          to: "/penyakit-hewan",
          icon: "stethoscope",
          type: "fa",
        },
        {
          name: "Pemotongan Hewan",
          to: "/pemotongan-hewan",
          icon: "scissors",
          type: "fa",
        },
      ],
      // Semua master menu (lengkap)
      allMasterMenus: [
        {
          name: "Wilayah",
          to: "/master-wilayah",
          icon: "map-pin",
          type: "fa",
        },
        {
          name: "Kelompok Tani",
          to: "/master-kelompok-tani",
          icon: "users",
          type: "fa",
        },
        {
          name: "Anggota Kelompok Tani",
          to: "/master-anggota-kelompok-tani",
          icon: "user-friends",
          type: "fa",
        },
        {
          name: "Kelompok Ternak",
          to: "/master-kelompok-ternak",
          icon: "paw",
          type: "fa",
        },
        {
          name: "Anggota Kelompok Ternak",
          to: "/master-anggota-kelompok-ternak",
          icon: "user",
          type: "fa",
        },
      ],
    };
  },
  watch: {
    "$route.path": {
      immediate: true,
      handler(newValue) {
        const parts = newValue.split("/");
        const link = parts[1];
        this.link = link;
        this.isMasterMenuOpen =
          this.link === "master-wilayah" ||
          this.link === "master-penyakit" ||
          this.link === "master-jenis-ternak" ||
          this.link === "master-anggota-kelompok" ||
          this.link === "master-kelompok-tani" ||
          this.link === "master-kelompok-ternak";

        this.$nextTick(() => {
          this.moveIndicator();
        });
      },
    },
    isMasterMenuOpen() {
      this.moveIndicator();
    },
  },
  computed: {
    // Menu Perkebunan yang difilter
    filteredPerkebunanMenus() {
      const role = this.userLevel;
      const sub = this.userSublevel;

      // Superadmin, admin_kabupaten, operator -> lihat semua
      if (role !== "admin_provinsi") {
        return this.allPerkebunanMenus;
      }

      // Admin provinsi berdasarkan sublevel
      if (sub === "produksi_perlindungan") {
        return this.allPerkebunanMenus.filter((m) =>
          ["/bantuan-perkebunan", "/bantuan-sphp"].includes(m.to),
        );
      }
      if (sub === "proteksi") {
        return this.allPerkebunanMenus.filter((m) =>
          ["/bantuan-sphp", "/pengamatan-opt"].includes(m.to),
        );
      }
      if (sub === "upt_mutu_sertifikasi") {
        return this.allPerkebunanMenus.filter(
          (m) => m.to === "/penangkar-benih",
        );
      }
      if (sub === "balai_perbenihan") {
        return this.allPerkebunanMenus.filter(
          (m) => m.to === "/kebun-sumber-benih",
        );
      }
      if (sub === "sarana_olah_hasil") {
        return this.allPerkebunanMenus.filter((m) => m.to === "/bantuan-sphp");
      }
      // Sublevel lain (peternakan) tidak lihat perkebunan
      return [];
    },

    // Menu Peternakan yang difilter
    filteredPeternakanMenus() {
      const role = this.userLevel;
      const sub = this.userSublevel;

      if (role !== "admin_provinsi") {
        return this.allPeternakanMenus;
      }

      if (sub === "admin_peternakan") {
        return this.allPeternakanMenus.filter(
          (m) => m.to === "/bantuan-ternak",
        );
      }
      if (sub === "pembibitan_ternak") {
        return this.allPeternakanMenus.filter(
          (m) => m.to === "/inseminasi-buatan",
        );
      }
      if (sub === "admin_keswan") {
        return this.allPeternakanMenus.filter((m) =>
          [
            "/lalu-lintas-ternak",
            "/penyakit-hewan",
            "/pemotongan-hewan",
          ].includes(m.to),
        );
      }
      return [];
    },

    // Menu Master Data yang difilter
    filteredMasterMenus() {
      const role = this.userLevel;
      const sub = this.userSublevel;

      if (role === "superadmin") {
        return this.allMasterMenus;
      }

      if (role === "admin_provinsi") {
        const wilayahMenus = this.allMasterMenus.filter((m) =>
          ["/master-wilayah"].includes(m.to),
        );
        const perkebunanSubs = [
          "produksi_perlindungan",
          "proteksi",
          "upt_mutu_sertifikasi",
          "balai_perbenihan",
          "sarana_olah_hasil",
        ];
        if (perkebunanSubs.includes(sub)) {
          return [
            ...wilayahMenus,
            ...this.allMasterMenus.filter((m) =>
              [
                "/master-kelompok-tani",
                "/master-anggota-kelompok-tani",
              ].includes(m.to),
            ),
          ];
        }
        if (
          sub === "admin_peternakan" ||
          sub === "pembibitan_ternak" ||
          sub === "admin_keswan"
        ) {
          return [
            ...wilayahMenus,
            ...this.allMasterMenus.filter((m) =>
              [
                "/master-kelompok-ternak",
                "/master-anggota-kelompok-ternak",
              ].includes(m.to),
            ),
          ];
        }
        return wilayahMenus;
      }

      if (role === "admin_kabupaten") {
        return this.allMasterMenus.filter((m) =>
          ["/master-wilayah"].includes(m.to),
        );
      }

      return [];
    },

    // Apakah menu Master Data perlu ditampilkan?
    showMasterMenu() {
      return this.filteredMasterMenus.length > 0;
    },
  },
  mounted() {
    this.moveIndicator();
  },
  methods: {
    moveIndicator() {
      this.$nextTick(() => {
        const activeEl = this.$el.querySelector(".modern-link.active");
        const indicator = this.$refs.indicator;

        if (activeEl && indicator) {
          const top =
            activeEl.offsetTop +
            activeEl.offsetHeight / 2 -
            indicator.offsetHeight / 2;

          indicator.style.top = top + "px";
        }
      });
    },
  },
};
